import FolderTreeViewStateStore from './schema/FolderTreeViewStateStore';
import MailFolderNodeViewState from './schema/MailFolderNodeViewState';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

// Import mutators so they are initialized at the same time as the store
import '../mutators/updateFolderCountsMutator';

const initialFolderTreeViewStateStore: FolderTreeViewStateStore = {
    folderNodeViewStates: new ObservableMap<string, MailFolderNodeViewState>({}),
    contextMenuState: null,
    folderTextFieldViewState: null,
    isDraggedOver: false,
    withContextMenuFolderId: null,
    shouldShowMoveDialog: false,
    moveToDestinationFolderId: null,
};

const store = createStore<FolderTreeViewStateStore>(
    'folderViewState',
    initialFolderTreeViewStateStore
)();

export default store;
